import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: theme.typography.h4.fontSize,
        fontWeight: 600,
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(2),
    },
    textField: {
        fontWeight: 600,
        '& >div>input': {
            textAlign: 'center',
            fontSize: theme.typography.h6.fontSize,
        }
    },
    sucesso: {
        width: 100,
        height: 100,
        fill: theme.palette.primary.main,
        marginBottom: theme.spacing(2),
    }
}))